import { render, staticRenderFns } from "./moduleAssigned.vue?vue&type=template&id=7b81f6e1"
import script from "./moduleAssigned.vue?vue&type=script&lang=js"
export * from "./moduleAssigned.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports